// extracted by mini-css-extract-plugin
export var createdDate = "_js-1";
export var divider = "_js-2";
export var headerDivider = "_js-3";
export var messagesCard = "_js-0";
export var messagesContainer = "_js-6";
export var messagesContainerWrapper = "_js-4";
export var showLeftPanelButton = "_js-8";
export var topButtons = "_js-7";
export var withPadding = "_js-5";